import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminCalendarEventsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('calendar-event');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
